export const getUsers = async () => (dispatch, result) => {
  // console.log(result, 'action');
  if (result) {
    dispatch({ type: 'GET_USERS', payload: result });
  }
};
